import React, { useState } from 'react';
import { Menu, MenuItem, IconButton, Tooltip } from '@material-ui/core';
import LanguageIcon from '@material-ui/icons/Language';
import i18n from './';

const LanguageSwitcher = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const currentLang = i18n.language || 'en';

    const handleOpen = (event) => setAnchorEl(event.currentTarget);
    const handleClose = (lang) => {
        if (lang) {
            i18n.changeLanguage(lang);
            localStorage.setItem('i18nextLng', lang);
        }
        setAnchorEl(null);
    };

    return (
        <>
            <Tooltip title="Language">
                <IconButton
                    aria-controls="lang-menu"
                    aria-haspopup="true"
                    onClick={handleOpen}
                    style={{ color: 'white', border: '1px solid white', borderRadius: '8px' }}
                    size="small"
                >
                    <LanguageIcon fontSize="small" />
                    <span style={{ marginLeft: 6, fontSize: '0.875rem' }}>{currentLang.toUpperCase()}</span>
                </IconButton>
            </Tooltip>

            <Menu
                id="lang-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => handleClose(null)}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <MenuItem onClick={() => handleClose('en')}> English</MenuItem>
                <MenuItem onClick={() => handleClose('fr')}> Français</MenuItem>
            </Menu>
        </>
    );
};

export default LanguageSwitcher;
